'use client';

import { useHyperliquidStore } from '@/stores/hyperliquidStore';

export default function TradePanel() {
  // Get order fills from store
  const orderFills = useHyperliquidStore(state => state.orderFills);

  // Format timestamp to readable time
  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  };

  // Format price with appropriate decimals
  const formatPrice = (price: string) => {
    const num = parseFloat(price);
    return num.toFixed(2);
  };

  // Format quantity with appropriate decimals
  const formatQuantity = (quantity: string) => {
    const num = parseFloat(quantity);
    return num.toFixed(6);
  };

  return (
    <div className='flex flex-1 shrink-0 flex-col rounded-lg lg:w-[263px] lg:border'>
      <div className='flex flex-col justify-center gap-3 px-2 py-2 lg:py-2.5'>
        <h3 className='hidden text-xs leading-none font-medium lg:block'>Trades</h3>
        <div className='grid grid-cols-3 border-gray-800 text-xs leading-none'>
          <div className='text-gray-400'>Price</div>
          <div className='text-right text-gray-400'>Size USD</div>
          <div className='text-right text-gray-400'>Time</div>
        </div>
      </div>

      <div className='flex flex-1 flex-col overflow-hidden'>
        <div className='flex flex-1 flex-col overflow-y-auto'>
          {orderFills.length === 0 ? (
            <div className='flex items-center justify-center py-8 text-xs text-gray-500'>No trades yet</div>
          ) : (
            orderFills.map((fill, i) => {
              const isBuy = fill.side.toLowerCase() === 'buy';

              return (
                <div
                  key={`${fill.orderId}-${fill.time}-${i}`}
                  className='grid cursor-pointer grid-cols-3 px-3 py-1 text-xs transition-colors hover:bg-gray-900/50'
                >
                  <div className={`font-mono ${isBuy ? 'text-green-400' : 'text-red-400'}`}>
                    {formatPrice(fill.price)}
                  </div>
                  <div className='text-right font-mono text-white'>{formatQuantity(fill.executedQuantity)}</div>
                  <div className='text-right font-mono text-gray-400'>{formatTime(fill.time)}</div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
